/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { Skeleton, Stack } from '@mui/material';
import { FC } from 'react';

const EMS_NAME = 'DPV2_PDP_Drawer_Aplazo';

export const AplazoDrawerList: FC = () => (
	<ContentRecommendation
		id={EMS_NAME}
		properties={{
			emsName: EMS_NAME,
		}}
		loadingElement={
			<Stack>
				<Skeleton variant="rectangular" height={100} />
				<Skeleton variant="rectangular" height={100} />
				<Skeleton variant="rectangular" height={100} />
				<Skeleton variant="rectangular" height={100} />
				<Skeleton variant="rectangular" height={100} />
			</Stack>
		}
	/>
);
